export const ru = {
    archive: 'Архивные',
    creatives: 'Мои креативы',
    upload: 'Загрузить'
};
